import { render, staticRenderFns } from "./video_01.vue?vue&type=template&id=2fa5d0e1&scoped=true&"
import script from "./video_01.vue?vue&type=script&lang=js&"
export * from "./video_01.vue?vue&type=script&lang=js&"
import style0 from "./video_01.vue?vue&type=style&index=0&id=2fa5d0e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5d0e1",
  null
  
)

export default component.exports